/* =====================================================================
   Tailwind (Play CDN) configuration — brand tokens for Bailey & Beau Co.
   Loaded AFTER the Tailwind CDN script so window.tailwind exists.
   ===================================================================== */
tailwind.config = {
  theme: {
    extend: {
      colors: {
        coral: '#F26B59',
        teal: '#46AFCE',
        tealdark: '#3B85A6',
        sun: '#FABA49',
        grass: '#41BA85',
        grape: '#9E7DBB',
        ink: '#5C5E5B',
        navy: '#2B2C6D',
        cream: '#FFFBF2',
        plum: '#764F84',
        berry: '#C84A70',
        gold: '#F0C75E',
        night: '#3D3B62',
        steelteal: '#3B86A6',
      },
      fontFamily: {
        display: ['"Baloo 2"', 'cursive'],
        body: ['Karla', 'sans-serif'],
      },
      maxWidth: { content: '1680px' },
    },
  },
};
